export function formatTooltipDate(date) {
  const d = new Date(date)
  return `${String(d.getUTCDate()).padStart(2, '0')} ${MONTHS[d.getUTCMonth()]} ${d.getUTCFullYear()}`
}

// Ratings that don't represent a grade on any provider's scale, but that we still plot —
// flat, at the previous rating — rather than dropping.
export const NO_RATING_LABELS = ['NR', 'PIF', 'WD', 'WR']
export const FITCH_CONVERSION = [
  'D',
  'DD',
  'DDD',
  'RD',
  'CCC',
  'B-',
  'B',
  'B+',
  'BB-',
  'BB',
  'BB+',
  'BBB-',
  'BBB',
  'BBB+',
  'A-',
  'A',
  'A+',
  'AA-',
  'AA',
  'AA+',
  'AAA',
]

// Ordered lowest-to-highest so value = index + 1.
export const MOODYS_CONVERSION = [
  'C',
  'Ca',
  'Caa3',
  'Caa2',
  'Caa1',
  'B3',
  'B2',
  'B1',
  'Ba3',
  'Ba2',
  'Ba1',
  'Baa3',
  'Baa2',
  'Baa1',
  'A3',
  'A2',
  'A1',
  'Aa3',
  'Aa2',
  'Aa1',
  'Aaa',
]

export const SNP_CONVERSION = [
  'D',
  'SD',
  'R',
  'C',
  'CC',
  'CCC-',
  'CCC',
  'CCC+',
  'B-',
  'B',
  'B+',
  'BB-',
  'BB',
  'BB+',
  'BBB-',
  'BBB',
  'BBB+',
  'A-',
  'A',
  'A+',
  'AA-',
  'AA',
  'AA+',
  'AAA',
]

export const X_AXIS_MIN_INTERVAL_MS = 1000 * 60 * 60 * 24

export const PROVIDER_SCALES = {
  MOODYS: { label: "Moody's", scale: MOODYS_CONVERSION },
  SNP: { label: 'S&P', scale: SNP_CONVERSION },
  FITCH: { label: 'Fitch', scale: FITCH_CONVERSION },
}
export const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
export const X_AXIS_MAX_INTERVAL_MS = 1000 * 60 * 60 * 24 * 365

export const TOOLTIP_FIELDS = [
  { label: 'Date', value: (point) => formatTooltipDate(point.data.date) },
  {
    label: 'Rating',
    value: (point, ctx) => point.data.ratingLabel ?? ctx.labelByValue[point.data.rating] ?? point.data.rating,
  },
  { label: 'Outlook', value: (point) => point.data.outlook },
  { label: 'Direction of Change', value: (point) => point.data.directionOfChange },
  { label: 'Watch', value: (point) => point.data.watch },
]
